import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createVNode as _createVNode, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, isRef as _isRef } from "vue"

const _hoisted_1 = { class: "component-set-list" }
const _hoisted_2 = { class: "list" }
const _hoisted_3 = { key: 0 }


import ItemSet from "@/components/set-item/index.vue";
import { useSets } from '@/composables/useSets'
import { NPagination } from "naive-ui";


export default /*#__PURE__*/_defineComponent({
  props: {
  id: String,
  keyword: String,
  maxLength: Number
},
  setup(__props) {

const props = __props



let { setsList, TotalCount, page } = useSets(props.id!, props.keyword!, props.maxLength!)

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(setsList).data, (data, i) => {
        return (_openBlock(), _createElementBlock(_Fragment, { key: i }, [
          (i < props.maxLength!)
            ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
                _createVNode(ItemSet, { data: data }, null, 8, ["data"])
              ]))
            : _createCommentVNode("", true)
        ], 64))
      }), 128))
    ]),
    _createVNode(_unref(NPagination), {
      "page-sizes": [props.maxLength],
      "item-count": _unref(TotalCount),
      page: _unref(page),
      "onUpdate:page": _cache[0] || (_cache[0] = ($event: any) => (_isRef(page) ? (page).value = $event : page = $event)),
      "show-quick-jumper": "",
      style: {"display":"flex","justify-content":"center","padding":"60px"}
    }, null, 8, ["page-sizes", "item-count", "page"])
  ]))
}
}

})